import * as React from 'react'

import { Redirect, Route, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app'
import { useAppRoutes, useFeatureFlag } from '@webapp/hooks'
import { OrderStatusPage } from '@webapp/pages'
import { Permissions } from '@webapp/platform/iam'
import { OrderDetailsPage } from './OrderDetailsPage'
import { OrderRequestPage } from './OrderRequestPage'
import { OrderDetailsPageTabs, OrderStatusPageStatuses } from './types'

const orderStatusFormat = Object.values(OrderStatusPageStatuses).join('|')
const orderDetailsTabFormat = Object.values(OrderDetailsPageTabs).join('|')

export const OrderRouter = () => {
  const { brp, url } = useAppRoutes()

  const RFO_AUTOMATION = useFeatureFlag('RFO_AUTOMATION')

  const orderDetailsPagePermissions = [
    Permissions.ADD_ORDER,
    Permissions.PROCURE_ADD_PO,
    Permissions.ACCOUNTS_PAYABLE_ADD_BILL,
    Permissions.ACCOUNTS_PAYABLE_CREATE_PAYMENTS,
    Permissions.APPROVE_ORDER,
    /**
     * @legacy
     * remove with `legacy-payments` switch
     */
    Permissions.LEGACY_PAYMENT,
  ]

  return (
    <Switch>
      {/* Order Request */}
      {RFO_AUTOMATION ? (
        <ProtectedRoute
          path={brp('OrderRequestPage')}
          component={OrderRequestPage}
          permissions={[Permissions.ADD_ORDER]}
        />
      ) : (
        <Redirect
          exact
          from={brp('OrderRequestPage')}
          to={url('LegacyOrderRequestPage')}
        />
      )}

      {/* Order Status */}
      <Redirect
        exact
        from={brp('OrderStatusPage', {
          status: '',
        })}
        to={url('OrderStatusPage', {
          status: OrderStatusPageStatuses.PENDING,
        })}
      />

      <ProtectedRoute
        path={brp('OrderStatusPage', {
          status: `:status(${orderStatusFormat})`,
        })}
        component={OrderStatusPage}
        navigationPermissions={['request__order']}
      />

      {/* Order Details */}
      <ProtectedRoute
        exact
        path={brp('OrderDetailsPage', { uuid: ':uuid' })}
        component={OrderDetailsPage}
        permissions={orderDetailsPagePermissions}
      />
      <ProtectedRoute
        exact
        path={brp('OrderDetailsPage', {
          uuid: ':uuid',
          tab: `:tab(${orderDetailsTabFormat})`,
        })}
        component={OrderDetailsPage}
        permissions={orderDetailsPagePermissions}
      />

      {/* Fallback for /orders/ */}
      <Route
        path='*'
        render={() => (
          <Redirect
            to={url('OrderStatusPage', {
              status: OrderStatusPageStatuses.PENDING,
            })}
          />
        )}
      />
    </Switch>
  )
}
